import './CategorySlider.scss'
import { Link } from 'react-router-dom'
import { Category } from '../../../../Models/Category'
import { Subcategory } from '../../../../Models/SubCategory'
import { CategoryAndSubcategoryMap } from '../../../../pages/CategoriesPage/categoriesPageController'
import { useEffect, useRef, useState } from 'react'

interface SubCategoryCardPropsInterface {
  subcategory: Subcategory
  category: Category
}

const SubcategoryCard = ({subcategory, category}: SubCategoryCardPropsInterface) => {

  const imageBoxClass = `imageBox category-${category.id.toString()}`;

  return (
    <div className="subCategoryCard">
      <Link to={"subcategory/" + subcategory.id + "/giglist"}>
        <div className={imageBoxClass}>
          <img src={subcategory.icon} alt="" />
        </div>
      </Link>
      <p>{subcategory.name}</p>
    </div>
  )
}

const CategorySlider = ({ category, subcategories }: CategoryAndSubcategoryMap) => {
  const sliderRef = useRef<HTMLElement>(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);

  const checkScrollability = () => {
    const slider = sliderRef.current;
    if (slider) {
      const hasOverflow = slider.scrollWidth > slider.clientWidth;
      setCanScrollLeft(hasOverflow && slider.scrollLeft > 0);
      setCanScrollRight(hasOverflow && slider.scrollLeft < slider.scrollWidth - slider.clientWidth - 1);
    }
  };

  useEffect(() => {
    // Ensure scroll starts at 0
    if (sliderRef.current) {
      sliderRef.current.scrollLeft = 0;
    }

    // Check scrollability after render
    const timer = setTimeout(() => {
      checkScrollability();
    }, 100);

    window.addEventListener('resize', checkScrollability);
    
    return () => {
      clearTimeout(timer);
      window.removeEventListener('resize', checkScrollability);
    };
  }, [subcategories]);

  const handleRightController = () => {
    const slider = sliderRef.current;
    if(slider) {
      const width = slider.clientWidth;
      slider.scrollLeft = slider.scrollLeft + width;
      setTimeout(checkScrollability, 100);
    }
  }
  
  const handleLeftController = () => {
    const slider = sliderRef.current;
    if(slider) {
      const width = slider.clientWidth;
      slider.scrollLeft = slider.scrollLeft - width;
      setTimeout(checkScrollability, 100);
    }
  }

  return (
    <section className='categorySliderSection'>
      <div className="categorySliderHeader">
        <h1>{category.title}</h1>
        <div className="sliderController">
          <button 
            className="controllerBtn controllerLeft" 
            onClick={handleLeftController} 
            disabled={!canScrollLeft}
            aria-label="Scroll left"
          >
            <i className="fa-solid fa-chevron-left"></i>
          </button>
          <button 
            className="controllerBtn controllerRight" 
            onClick={handleRightController} 
            disabled={!canScrollRight}
            aria-label="Scroll right"
          >
            <i className="fa-solid fa-chevron-right"></i>
          </button>
        </div>
      </div>
      <section 
        className='categorySlider' 
        id={'categorySlider-' + category.id}
        ref={sliderRef}
        onScroll={checkScrollability}
      >
        { 
          subcategories.map((subCategory: Subcategory) => (<SubcategoryCard key={subCategory.id} subcategory={subCategory} category={category}/>))
        }
      </section>
    </section>
  )
}

export default CategorySlider